// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/b20abe46/" + chunkId + "." + __webpack_require__.h() + ".vb20abe46.js";
};